import { BaseTheme } from "@swiggy-private/dls-web-common/dist/components/themes/precomputed/Base/BaseTheme";
import { getCloudinaryRawUrl } from "@swiggy-private/js-utils";

const PREFIX = "m2c-halfcard";

export const M2C_HALFCARD_TEST_IDS = {
    HALFCARD: `${PREFIX}-halfcard`,
    TITLE: `${PREFIX}-title`,
    TITLE_V2: `${PREFIX}-title-v2`,
    SUBTITLE: `${PREFIX}-subtitle`,
    SUBTITLE_V2: `${PREFIX}-subtitle-v2`,
    PRIMARY_CTA: `${PREFIX}-primary-cta`,
    SECONDARY_CTA: `${PREFIX}-secondary-cta`,
    CLOSE_BUTTON: `${PREFIX}-close-button`,
    LOGO: `${PREFIX}-logo`,
    LOGO_V2: `${PREFIX}-logo-v2`,
    NOTE: `${PREFIX}-note`,
    DE: `${PREFIX}-delivery-executive`,
    GRATIFICATION_HEADER: `${PREFIX}-gratification-header`,
    GRATIFICATION_TITLE: `${PREFIX}-gratification-title`,
    GRATIFICATION_LOTTIE_CONTAINER: `${PREFIX}-gratification-lottie-container`,
};

export const ASSET_PATH = "portal/m/m2c_card_comms";

export const FULL_RAY_BACKGROUND = `${ASSET_PATH}/full_ray.png`;
export const HALF_RAY_BACKGROUND = `${ASSET_PATH}/half_ray.png`;
export const DELIVERY_EXECUTIVE = `${ASSET_PATH}/swiggy_DE.png`;
export const DELIVERY_EXECUTIVE_SHADOW = `${ASSET_PATH}/DE_shadow_v2.png`;
export const COINES_AND_STARS = `${ASSET_PATH}/coins_and_stars.png`;
export const XP2_MASTHEAD = `${ASSET_PATH}/XP-masthead-without-logo.png`;
export const STRIP_HEADER = `portal/m/bulls-eye-cart-upsell/header_background.png`;
export const ZIGZAG_PATTERN = `${ASSET_PATH}/zigzag_pattern_v2.png`;
export const SPARKLING_STARS = `${ASSET_PATH}/stars.png`;

// External rays background for PLUS variant
export const RAYS_BACKGROUND_URL = "portal/m/m2c_card_comms/rays%20520%20width.png";

export const DISABLE_GREY_FROM_IMG = { light: "", dark: "" };

export const backgroundImageFormate = (url: string) => `url(${url})`;

export const GRATIFICATION_FALLBACK_HEIGHT = 400;

export const COLOR_TAGS = {
    OPEN: `<span style="color:${BaseTheme.colors[BaseTheme.colorMode].primary};">`,
    CLOSE: `</span>`,
};

export const STRIKED_TAGS = {
    TO_FIND: `<s>`,
    TO_BE_REPLACED: `<s style="color:${BaseTheme.colors[BaseTheme.colorMode].text_Low_Emphasis};">`,
};

export const DEFAULT_PROGRESS_DURATION = 3;
export const THOUSAND = 1000;
/**
 * The delay (in milliseconds) for state change from preState to postState to make transition smoother.
 */
export const STATE_CHANGE_DELAY = 800;

export const CLOSED_CTA_TEXT = "Cross icon";
export const POST_STATE_CLOSE_CTA_TEXT = "Auto closed after post state duration";
export const SWIGGY_ONE_LITE_ADDED_TEXT = "Swiggy One Lite added!";
export const SWIGGY_ONE_ADDED_TEXT = "Swiggy One added!";
export const BILL_SUBTEXT_ONE = "Total bill reduced by\r{0} with One!";
export const BILL_SUBTEXT_ONE_LITE = "Total bill reduced by\r{0} with One Lite!";

export const EMPTY_FUNCTION = (): void => void 0;

export const DELIVERY_EXECUTIVE_PROPS = {
    width: "134px",
    height: "128px",
    customBackground: { ...DISABLE_GREY_FROM_IMG },
};

export const SWIGGY_LOGO_PROPS = {
    alt: "Swiggy Logo",
    width: "100px",
    height: "42px",
    customBackground: { ...DISABLE_GREY_FROM_IMG },
};

export const XP2_MASTHEAD_PROPS = (isOneLite?: boolean) => ({
    height: isOneLite ? "34" : "32",
    width: isOneLite ? "176" : "90",
    alt: "XP2 Masthead logo",
    customBackground: { ...DISABLE_GREY_FROM_IMG },
});

export const GRATIFICATION_POPUP_LOTTIE_TIMEOUT = 5000;

export const GRATIFICATION_POPUP_LOTTIE_LAYER_NAMES = {
    PLAN_NOT_ADDED: "previousAmount",
    PLAN_ADDED: "updatedAmount",
    HEADING: "headingText",
    BILL_SUBTEXT: "billSubtext",
    WITHOUT_TEXT: "withoutOneText",
};

export const PLAN_REMOVAL_HALF_CARD = "WITHOUT ONE";

export const GRATIFICATION_POPUP_LOTTIE = getCloudinaryRawUrl("portal/m/loyalty/gratification_lottie.json");

export const GRATIFICATION_POPUP_LOTTIE_ASSETS = {
    STATIC_HEADER_ASSET: "portal/m/loyalty/grtfctnppp_hdr.png",
    ONE_LOGO: "portal/m/loyalty/One.png",
    ONE_LITE_LOGO: "portal/m/loyalty/OneLite.png",
};

export const LOTTIE_PLAYER_CONTAINER_TEST_ID = "gratification-lottie-container";

export const GRATIFICATION_POPUP_LOTTIE_SELECTORS = {
    SVG_SELECTOR: `[data-testid='${LOTTIE_PLAYER_CONTAINER_TEST_ID}'] svg > g:not(defs g)`,
    YAY_LAYER_SELECTOR: `:scope > g[aria-label='YAY!']`,
};
export const GRATIFICATION_HALF_CARD_LOTTIE = getCloudinaryRawUrl(
    "portal/static-assets/hcms/remove_plan_half_card.json",
);

export const GRATIFICATION_HALF_CARD_LOTTIE_ASSETS = "portal/testing/one-halfcard-lottie/lottie-v2/img_{0}.png";

export const GRATIFICATION_HALF_CARD_LOTTIE_LOGO = {
    ONE_LITE: "portal/static-assets/hcms/one_lite.png",
    ONE: "portal/static-assets/hcms/One.png",
};

export const HALF_CARD_LOTTIE_IMAGES_ASSET_COUNT = 3;
